import { useMutation } from "@tanstack/react-query";

import type { MutationConfig } from "@/lib/react-query";
import { authApi } from "@/lib/api-client";
import { apiPaths } from "@/config/paths";
import { AxiosResponse } from "axios";

type ResetPasswordPetitionInput = {
  email: string;
};

type ResetPasswordPetitionResponse = {
  success: boolean;
};

const resetPasswordPetition = ({
  data,
}: {
  data: ResetPasswordPetitionInput;
}): Promise<AxiosResponse<ResetPasswordPetitionResponse>> => {
  return authApi.post<ResetPasswordPetitionInput, AxiosResponse<ResetPasswordPetitionResponse>>(
    apiPaths.auth.resetPasswordPetition.getPath(),
    data
  );
};

type UseResetPasswordPetitionOptions = {
  mutationConfig?: MutationConfig<typeof resetPasswordPetition>;
};

export const useResetPasswordPetition = ({ mutationConfig }: UseResetPasswordPetitionOptions = {}) => {
  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    onSuccess: (data, ...args) => {
      onSuccess?.(data, ...args);
    },
    ...restConfig,
    mutationFn: resetPasswordPetition,
  });
};
